export default __webpack_public_path__ + "static/media/sd-kum.02e54054.jpg";